import { InternalAxiosRequestConfig } from 'axios';

/**
 * Otomatik iptal ozelligi su an KAPALI. Kapali iken hicbir istege
 * AbortController baglanmaz ve route degisiminde iptal yapilmaz; istekler
 * ozellik eklenmeden onceki gibi normal sekilde tamamlanir.
 *
 * Tekrar acmak icin tek yapilacak: asagidaki degeri `true` yapmak.
 */
export const AUTO_CANCEL_ENABLED = false;

/**
 * Sayfa degisiminde bekleyen isteklerin iptali icin kayit defteri.
 *
 * Her istek, baslatildigi andaki pathname ile damgalanir. Route degistiginde
 * yalnizca damgasi guncel pathname'den FARKLI olan istekler iptal edilir.
 *
 * Bu damga sart: React'te child effect'leri parent'tan once kosar, yani yeni
 * sayfanin bilesenleri isteklerini App'in location effect'inden ONCE atar.
 * "Tum bekleyen istekleri iptal et" denseydi yeni sayfanin istekleri iptal
 * edilirdi. React Router history API'ini senkron kullandigi icin yeni sayfanin
 * istekleri zaten yeni pathname ile damgalanir ve iptalden muaf kalir.
 */
const pending = new Map<AbortController, string>();

export function registerRequest(
  controller: AbortController,
  pathname: string
): void {
  pending.set(controller, pathname);
}

export function unregisterRequest(controller?: AbortController): void {
  if (controller) {
    pending.delete(controller);
  }
}

export function cancelStaleRequests(currentPathname: string): void {
  if (!AUTO_CANCEL_ENABLED) {
    return;
  }

  pending.forEach((pathname, controller) => {
    if (pathname !== currentPathname) {
      controller.abort();
      pending.delete(controller);
    }
  });
}

/** Sadece testler icin: defteri sifirlar. */
export function resetRequestRegistry(): void {
  pending.clear();
}

export type CancelableRequestConfig = InternalAxiosRequestConfig & {
  __abortController?: AbortController;
};

/**
 * `skipAutoCancel: true` ile isaretlenen istekler route degisiminde iptal
 * edilmez. Auth bootstrap'i, icerik yuklemesi, dosya yukleme, odeme ve
 * fire-and-forget analitik cagrilari icin kullanilir.
 *
 * `skipForcedLogout: true` ile isaretlenen istekte 401/403, zorla cikis ve
 * login yonlendirmesi tetiklemez; yalnizca lokal state temizlenir. Auth
 * bootstrap'i (checkToken -> getMe) icindir: anonim her sayfa yuklemesinde
 * 401 alinir ve silinecek bir cerez yoktur.
 *
 * `skipGlobalErrorModal: true` ile isaretlenen istekte jenerik `ApiErrorModal`
 * acilmaz; cagiran bilesen hatayi kendi UI'inda gosterir. Parola suresi dolmus
 * akisinin iki ucu icindir: Ekran 2 kendi hata metnini/checklist'ini gosterir,
 * ustune bir de global modal binmemeli.
 */
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipAutoCancel?: boolean;
    skipForcedLogout?: boolean;
    skipGlobalErrorModal?: boolean;
  }
}
